module.exports = __webpack_public_path__ + "static/media/previous-result-arrow.0fda7975.png";